import React, { useState } from "react";
import { Download, FileSpreadsheet, FileText, Building2, CreditCard } from "lucide-react";

const API = process.env.REACT_APP_API_BASE || "http://127.0.0.1:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const EXPORTS = [
  { key: "payroll-register", label: "Payroll Register",   icon: FileSpreadsheet, fmt: "excel", desc: "All employees, all components"    },
  { key: "bank-file",        label: "Bank Transfer File", icon: CreditCard,      fmt: "csv",   desc: "NEFT/ACH disbursement file"       },
  { key: "payslips",         label: "Bulk Payslips",      icon: FileText,        fmt: "zip",   desc: "All payslips as PDF zip"          },
  { key: "statutory",        label: "Statutory Register", icon: Building2,       fmt: "excel", desc: "PF, ESI, PT, TDS summaries"      },
  { key: "gl-summary",       label: "GL Summary",         icon: FileSpreadsheet, fmt: "csv",   desc: "Journal entries for accounts"    },
  { key: "variance",         label: "Variance Report",    icon: FileSpreadsheet, fmt: "excel", desc: "MoM changes in pay components"   },
];

export default function ExportPanel({ month, totals }) {
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);

  const download = async (key, fmt) => {
    setBusy(key); setError(null);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API}/api/admin/payroll/export/${key}?month=${month}&format=${fmt}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      const ext  = fmt === "excel" ? "xlsx" : fmt === "zip" ? "zip" : "csv";
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href = url; a.download = `payroll_${key}_${month}.${ext}`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { setError(e.message); }
    finally { setBusy(null); }
  };

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Exports — {month}</span>
        {totals?.net != null && (
          <span className="text-xs text-white/30">Net ₹{Number(totals.net).toLocaleString("en-IN")}</span>
        )}
      </div>
      <div className="p-5 space-y-3">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {EXPORTS.map(({ key, label, icon: Icon, fmt, desc }) => (
            <button key={key} onClick={() => download(key, fmt)} disabled={busy !== null}
              className="text-left rounded-lg border border-white/5 bg-white/3 p-3 hover:border-[#00ff90]/20 hover:bg-[#00ff90]/5 disabled:opacity-40 transition-all group">
              <div className="flex items-center gap-2 mb-1">
                <Icon size={13} className="text-[#00ff90]/40 group-hover:text-[#00ff90]/70 transition-colors" />
                <span className="text-xs text-white/60 font-medium group-hover:text-white/80 transition-colors">{label}</span>
                {busy === key && <span className="text-xs text-[#00ff90]/50 ml-auto">…</span>}
                {busy !== key && <Download size={11} className="text-white/20 ml-auto group-hover:text-[#00ff90]/50 transition-colors" />}
              </div>
              <p className="text-xs text-white/25">{desc}</p>
            </button>
          ))}
        </div>
        {error && <p className="text-red-400 text-xs">⚠ {error}</p>}
      </div>
    </div>
  );
}